import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// ZAMENI OVE VREDNOSTI SA TVOJIM FIREBASE PROJEKTOM
// Uputstvo: https://console.firebase.google.com → New Project → Web App
const firebaseConfig = {
  apiKey: "AIzaSyCDaY2r-1oukuRkSM01D5aFnKJHvqvKKQU",
  authDomain: "pritisakrs-beta.firebaseapp.com",
  projectId: "pritisakrs-beta",
  storageBucket: "pritisakrs-beta.firebasestorage.app",
  messagingSenderId: "232897914533",
  appId: "1:232897914533:web:0dc1a47f6af28c1c2d0f4c",
  measurementId: "G-2N9Y8RZ2SB"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
